import React from 'react'
import { useChildrenToStringL10n } from '~/common/childrenUtils'
import { Checkbox, Text } from '~/design_system'
import { useIsMounting } from '~/common/nextJsUtils'

const sx = { '& > .chakra-checkbox__label': { overflow: 'hidden' } }
const truncateStyles = { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }

/**
 * CheckboxListCheckbox component
 * @param props {import('@chakra-ui/react').CheckboxProps & {truncate?: boolean}}
 * @returns {React.JSX.Element}
 */
const Component = ({ children, truncate = true, ...props }) => {
  const isMounting = useIsMounting()
  const childrenToStringL10n = useChildrenToStringL10n()
  return (
    <Checkbox
      pr={2}
      size="lg"
      title={childrenToStringL10n(children)}
      sx={sx}
      {...props}
      // Next line is to prevent SSR hydration mismatches
      // So checkbox will always start as unchecked and disabled on first render
      {...(isMounting && { isChecked: false, isDisabled: true })}>
      <Text fontSize="md" h="auto" pos="relative" top="1px" {...(truncate && truncateStyles)}>
        {children}
      </Text>
    </Checkbox>
  )
}
export const CheckboxListCheckbox = React.memo(Component)
